// extracted by mini-css-extract-plugin
export default {"img-cover":"SignOut_img-cover__IoKfQ"};